/**
 * Analytics utilities for frontend tracking
 * Integrates with PostHog for event tracking
 */

// PostHog is loaded via snippet in index.html
// Access it via window.posthog
let posthog = null;

export function initPostHog() {
  // PostHog is already initialized via snippet in index.html
  // Just get reference to it
  if (typeof window !== 'undefined' && window.posthog) {
    posthog = window.posthog;
    if (process.env.NODE_ENV === 'development') {
      console.log('PostHog loaded via snippet');
    }
  }
}

// Get or create session ID
export function getSessionId() {
  if (typeof window === 'undefined') return null;
  
  let sessionId = sessionStorage.getItem('rhinovate_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('rhinovate_session_id', sessionId);
  }
  return sessionId;
}

// Get or create user ID (anonymous)
export function getUserId() {
  if (typeof window === 'undefined') return null;
  
  let userId = localStorage.getItem('rhinovate_user_id');
  if (!userId) {
    userId = `user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('rhinovate_user_id', userId);
  }
  return userId;
}

// Track events
export function trackEvent(eventName, properties = {}) {
  if (!posthog) return;
  
  const sessionId = getSessionId();
  const userId = getUserId();
  
  posthog.capture(eventName, {
    ...properties,
    session_id: sessionId,
    user_id: userId,
    timestamp: new Date().toISOString()
  });
}

// Track photo upload
export function trackPhotoUpload(properties = {}) {
  trackEvent('photo_uploaded', {
    ...properties,
    event_type: 'photo_upload'
  });
}

// Track AI generation
export function trackAIGeneration(properties = {}) {
  trackEvent('ai_generation_started', {
    ...properties,
    event_type: 'ai_generation'
  });
}

// Track share/download
export function trackShare(shareType = 'download', properties = {}) {
  trackEvent('result_shared', {
    ...properties,
    share_type: shareType,
    event_type: 'share'
  });
}

// Track user feedback
export function trackFeedback(feedbackType, rating = null, properties = {}) {
  trackEvent('user_feedback', {
    ...properties,
    feedback_type: feedbackType,
    rating: rating,
    event_type: 'user_feedback'
  });
}

// Track page views
export function trackPageView(pageName) {
  trackEvent('$pageview', {
    page_name: pageName
  });
}

